import React, { Fragment } from "react";
import { FunctionField, ReferenceManyField, ShowButton, translate } from "react-admin";
import resources from "../../config/resources";
import PlainShow from "../PlainShow";
import Paper from "@material-ui/core/Paper/Paper";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import { withStyles } from "@material-ui/core/styles";
import { getKey } from "../../lib/i18nUtils";
import PriceField from "../customFields/PriceField";
import DocumentsBox from "../documents/DocumentsBox";
import CommentBox from "../comments/CommentBox";
import ArchivedModelDatagrid from "../archivedModels/ArchivedModelDatagrid";

const styles = theme => ({
  infoBox: {
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
  },
  modelsBox: {
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    paddingLeft: 0,
    paddingRight: 0,
  },
  table: {
    overflowX: "auto",
  },
  inlineButton: {
    display: "inline",
    marginBottom: 0,
    marginTop: "-" + theme.typography.body1.fontSize,
    height: theme.typography.body1.fontSize,
  },
  negMarginButton: {
    marginTop: `-${theme.spacing.unit * 2}px`,
    marginBottom: `-${theme.spacing.unit * 2}px`,
  },
});

const ShowRow = ({ translate, ...props }) => (
  <div style={{ width: "100%", textAlign: "right" }}>
    <ShowButton {...props} label={translate(getKey("showContractorView", resources.ARCHIVED_JOBS))} />
  </div>
);

const ArchivedJobPanel = ({ translate, classes, permissions, ...props }) => (
  <PlainShow {...props} title="" location="">
    <Fragment>
      <DocumentsBox {...props} permissions={permissions} style={{ marginLeft: -8 }} archivedView target="job#id" />
      <Paper className={classes.modelsBox}>
        <ReferenceManyField target="job#id" {...props} reference={resources.ARCHIVED_MODELS} source="__id">
          <ArchivedModelDatagrid {...props} base={props.basePath} permissions={permissions} job={props.record} />
        </ReferenceManyField>
        <ShowRow {...props} translate={translate} />
      </Paper>
      <Paper className={classes.modelsBox} style={{ padding: 8 }}>
        <Typography variant="title" style={{ marginBottom: 16 }}>
          {translate(getKey("price", resources.ARCHIVED_JOBS))}
        </Typography>
        {props.record.minimumPriceCurrency && (
          <Grid container>
            <Grid item xs={2}>
              <Typography variant="body1">{translate(getKey("minimumPrice", resources.ARCHIVED_JOBS))}:</Typography>
            </Grid>
            <Grid item xs={2}>
              <PriceField {...props} currencySource="minimumPriceCurrency" valueSource="minimumPriceValue" />
            </Grid>
          </Grid>
        )}
        {props.record.partsPriceCurrency && (
          <Grid container>
            <Grid item xs={2}>
              <Typography variant="body1">{translate(getKey("partsPrice", resources.ARCHIVED_JOBS))}:</Typography>
            </Grid>
            <Grid item xs={2}>
              <PriceField {...props} currencySource="partsPriceCurrency" valueSource="partsPriceValue" />
            </Grid>
          </Grid>
        )}
        {props.record.transportPriceCurrency && (
          <Grid container>
            <Grid item xs={2}>
              <Typography variant="body1">{translate(getKey("transportPrice", resources.ARCHIVED_JOBS))}:</Typography>
            </Grid>
            <Grid item xs={2}>
              <PriceField {...props} currencySource="transportPriceCurrency" valueSource="transportPriceValue" />
            </Grid>
          </Grid>
        )}
        {props.record.discountCurrency && (
          <Grid container>
            <Grid item xs={2}>
              <Typography variant="body1">{translate(getKey("discount", resources.ARCHIVED_JOBS))}:</Typography>
            </Grid>
            <Grid item xs={2}>
              <PriceField {...props} currencySource="discountCurrency" valueSource="discountValue" />
            </Grid>
          </Grid>
        )}
        {props.record.priceCurrency && (
          <Grid container>
            <Grid item xs={2}>
              <Typography variant="body2">{translate(getKey("totalPrice", resources.ARCHIVED_JOBS))}:</Typography>
            </Grid>
            <Grid item xs={2}>
              <PriceField {...props} currencySource="priceCurrency" valueSource="priceValue" />
            </Grid>
          </Grid>
        )}
      </Paper>
      <FunctionField
        {...props}
        addLabel={false}
        render={record =>
          permissions &&
          permissions.authorities.includes("ROLE_SALES") && (
            <CommentBox
              {...props}
              record={record}
              jobId={record.id}
              permissions={permissions}
              reference={resources.ARCHIVED_COMMENTS}
            />
          )
        }
      />
    </Fragment>
  </PlainShow>
);

export default withStyles(styles)(translate(ArchivedJobPanel));
